module.exports = __webpack_public_path__ + "static/media/the-gordon.881bd9fe.jpg";